import { Icon } from '@/components/foundations';
import { Badge, DataTable } from '@/components/data';

export type CategoryRule = {
  /** Tipo (ex.: "Descrição contém", "CNPJ", "MCC"). */
  type: string;
  pattern: string;
  /** Categoria aplicada; "Ignorar" tira o lançamento das contas. */
  category: string;
  /** Lançamentos afetados. */
  count: number;
};

/** Regras de categorização em ordem de prioridade. */
export function RulesTable({ rules, onSelect }: { rules: readonly CategoryRule[]; onSelect?: (rule: CategoryRule) => void }) {
  return (
    <DataTable
      rows={rules}
      rowKey={(r) => r.pattern}
      onRowClick={onSelect}
      columns={[
        { key: 'n', header: '#', render: (_, i) => i + 1 },
        { key: 'type', header: 'Tipo', render: (r) => r.type },
        { key: 'pattern', header: 'Padrão', render: (r) => <span className="mono">{r.pattern}</span> },
        { key: 'cat', header: 'Categoria', render: (r) => <Badge tone={r.category === 'Ignorar' ? 'err' : 'gold'}>{r.category}</Badge> },
        { key: 'count', header: 'Lançamentos', align: 'right', render: (r) => r.count },
        { key: 'go', header: '', align: 'right', render: () => <Icon name="chev" className="chev-c" /> },
      ]}
    />
  );
}
